module.exports = __webpack_public_path__ + "static/media/warn.b5412074.svg";